






























































import {
  Component, Vue, Watch,
} from 'vue-property-decorator';
import AddIcon from 'mdi-vue/Plus';
import dayjs from 'dayjs';

import Table from '@/components/Table/Table.vue';
import TableBody from '@/components/Table/TableBody.vue';
import Row from '@/components/Table/Row.vue';
import Header from '@/components/Table/Header.vue';
import Cell from '@/components/Table/Cell.vue';
import Button from '@/components/Button.vue';
import Loader from '@/components/Loader.vue';
import StatusIndicator from '@/components/StatusIndicator.vue';
import Pagination from '@/components/Pagination.vue';
import ActionPopup from '@/components/ActionPopup.vue';
import ScrollbarWrapper from '@/components/ScrollbarWrapper.vue';

import api from '@/libs/api';
import format from '@/libs/numberFormat';
import {
  InvoiceResponse, Invoice, Service,
} from '@/libs/api.interfaces';
import { AxiosError } from 'axios';

interface ReportParams {
  merchant: { merchant_code: string; merchant_name: string } | null;
  month: LabelValue | null;
  year: LabelValue | null;
  status: LabelValue | null;
  service: Service | null;
}

@Component({
  components: {
    ScrollbarWrapper,
    Button,
    AddIcon,
    Table,
    TableBody,
    Row,
    Header,
    Cell,
    Loader,
    StatusIndicator,
    Pagination,
    ActionPopup,
  },
  methods: {
    format,
  },
})
export default class InvoiceTable extends Vue {
  loading = true;
  invoices: Invoice[] = [];

  // pagination
  page = 1;
  totalPage = 1;
  from = 0;
  to = 0;
  totalItem = 0;

  format!: (val: string) => string;

  statuses = [
    '',
    'CLAIM',
    'PENDING',
    'GENERATED',
  ];

  @Watch('page')
  onPageChange() {
    this.$router.push({
      query: { ...this.$route.query, page: this.page.toString() },
    });
  }

  async getInvoice(params: ReportParams, page = 1) {
    try {
      this.loading = true;

      const merchant = params.merchant ? params.merchant.merchant_code : undefined;
      const year = params.year && params.year.value !== '0' ? params.year.value : 0;
      const month = params.month && params.month.value !== '0' ? params.month.value : 0;
      const status = params.status && params.status.value !== '0' ? params.status.value : undefined;
      const service = params.service && params.service.service_code !== 'All'
        ? params.service.service_dbname : undefined;

      const { data } = await api.get<InvoiceResponse>('/merchant-invoice', {
        params: {
          page,
          // eslint-disable-next-line @typescript-eslint/camelcase
          merchant_code: merchant,
          period: year === 0 && month === 0 ? undefined : `${year}-${month}`,
          status,
          service,
        },
      });

      this.page = page;
      this.invoices = data.data;
      this.totalPage = Math.ceil(data.total / data.per_page);
      this.from = data.from;
      this.to = data.to;
      this.totalItem = data.total;
      this.loading = false;

      return null;
    } catch (err) {
      console.error(err);
      return err as AxiosError;
    }
  }

  // eslint-disable-next-line class-methods-use-this
  dateFormat(time: string) {
    const formatted = dayjs(time).format('MMMM D, YYYY HH:mm:ss');
    if (formatted === 'Invalid Date') {
      return '-';
    }

    return formatted;
  }

  // eslint-disable-next-line class-methods-use-this
  periodFormat(time: string) {
    const formatted = dayjs(time, 'MM-YYYY').format('MMMM YYYY');
    if (formatted === 'Invalid Date') {
      return '-';
    }

    return formatted;
  }
}
